module.exports = __webpack_public_path__ + "img/Desktop_Process-Graphic.a86f5d7f.svg";